module.exports = __webpack_public_path__ + "media/images/front/materiales_mid_m-8f4104521cdaa567c7e5fcfdc429379b.png";